import { IoCloudUpload } from "react-icons/io5";
import { EmptyFilePreview } from "./EmptyFilePreview";
import { FilePreview } from "./FilePreview";

export function UploadScreen(props: {
    files: File[];
    isDragActive: boolean;
    getInputProps: () => React.InputHTMLAttributes<HTMLInputElement>;
    setTotalFiles: React.Dispatch<React.SetStateAction<File[]>>;
    onRemove: (file: File) => void;
}) {
    const { files, isDragActive, getInputProps, setTotalFiles, onRemove } = props
    return (
        <div>
            <IoCloudUpload className="mx-auto text-4xl text-gray-500" />

            {files.length > 0 ? files.map(file => (
                <FilePreview key={file.name} file={file} onRemove={onRemove} />
            )) : <EmptyFilePreview isDragActive={isDragActive} />}

            <input {...getInputProps()} />

            {files.length > 0 && <button className="px-4 py-2 text-sm text-gray-500 bg-gray-100 rounded-md" onClick={(e) => { e.stopPropagation(); setTotalFiles([])  }}>Clear</button>}

        </div>
    );
}
